import { Euler } from "three";
import imageSource from "@assets/models/guns/uzi/sprite/uzi-side-drawn.png";
import { Hitscan } from "../mechanics/bullets";
import { AutomaticFiring, BurstFiring, FiringModeManager, ProceduralRecoil, SemiAutomaticFiring, } from "../mechanics";
import { ModelMeshController } from "@controllers/mesh";
import { BoneController } from "../../bones";
class Uzi {
    name;
    meshController;
    imageSource;
    damagePerHit;
    fireRatePerSecond;
    shootingMechanic;
    skeleton;
    firingModeManager;
    recoil;
    /**
     * An Uzi gun.
     * @throws Throws an error if the given firing type is incompatible with the gun.
     */
    constructor(assetLoader) {
        this.name = "Uzi";
        this.meshController = new ModelMeshController(assetLoader.getWeaponAssets.skorpion.modelLoader, false, true, 0.0014, new Euler(0, -Math.PI, 0));
        this.imageSource = imageSource;
        this.skeleton = {
            muzzle: new BoneController("MuzzleBone", this.meshController.getMesh),
            handle: new BoneController("Handle", this.meshController.getMesh),
            foregrip: new BoneController("Foregrip", this.meshController.getMesh),
        };
        this.shootingMechanic = new Hitscan();
        this.firingModeManager = new FiringModeManager(new AutomaticFiring(), [
            new AutomaticFiring(),
            new BurstFiring(),
            new SemiAutomaticFiring(),
        ]);
        this.recoil = new ProceduralRecoil(new Euler(0.03, 0.01, 0.01));
        this.damagePerHit = 34;
        this.fireRatePerSecond = 10;
    }
    /**
     * Shoots the gun at the received entities.
     *
     * Handles rate of fire as well as dealing damage to the entities that were hit.
     * @param entities The entities to check for hits.
     * @param terrain The terrain to check for hits.
     * @param originPosition The position from which the shot originates.
     * @param originDirection The direction of the entity that took the shot.
     */
    shoot(entities, terrain, originPosition, originDirection) {
        if (!this.firingModeManager.getFiringMode.canFire)
            return;
        if (this.shootingMechanic.shoot(entities, terrain, originPosition, originDirection, this.fireRatePerSecond, this.damagePerHit) === false)
            return;
        this.firingModeManager.getFiringMode.onShoot();
        this.recoil.recoil();
    }
    /**
     * Perform a step on the gun.
     * This mainly involves handling recoil.
     * @param entity The entity to apply recoil to.
     * @param inputController The entity's input controller, to register when shooting stops.
     */
    step(entity, inputController) {
        this.recoil.step(entity.getSkeleton.chest.getBone);
        if (!this.firingModeManager.getFiringMode.canFire && !inputController.getSHOOTING) {
            this.firingModeManager.getFiringMode.onStopShooting();
        }
    }
    get getName() {
        return this.name;
    }
    get getMeshController() {
        return this.meshController;
    }
    get getImageSource() {
        return this.imageSource;
    }
    get getFiringModeManager() {
        return this.firingModeManager;
    }
    get getDamagePerHit() {
        return this.damagePerHit;
    }
    get getSkeleton() {
        return this.skeleton;
    }
    get getFireRatePerSecond() {
        return this.fireRatePerSecond;
    }
}
export { Uzi };
